'use strict';

import React from 'react';

// import FaFacebook from 'react-icons/lib/fa/facebook';
// import FaLinkedIn from 'react-icons/lib/fa/linkedin';
// import FaExternalLink from 'react-icons/lib/fa/external-link';
// import FaEnvelope from 'react-icons/lib/fa/envelope';
// import OwlCarousel from 'react-owl-carousel';
// import FaFacebook from 'react-icons/lib/fa/facebook';
import FaClose from 'react-icons/lib/fa/close'

class Client extends React.Component {
  constructor(props) {
    super(props)
    this.showClient = this.showClient.bind(this)
    this.hideClient = this.hideClient.bind(this)
    this.state = {
      showingClient: false
    }
  }

  showClient(e) {
    //console.log(e)
    this.setState({
      showingClient: true
    })
  }

  hideClient(e) {
    //console.log(e)
    this.setState({
      showingClient: false
    })
  }

  render() {
    const client = this.props.client;
    client.links = client.links.sort((a,b) => a.order < a.order)
    client.links.forEach((element, i) => {
      client.links[i].image = element.image.replace('/api/v1/clients', '');
    });
    return (
      <div className="item">
        <div onClick={this.showClient} className={'main-image-wraper' + (this.state.showingClient ? ' hidden' : '')}>
          <img className="lazyload" data-src={client.links[client.main_image].image} alt={client.name} />
        </div>
        <div className={'portfolio-single' + (!this.state.showingClient ? ' hidden' : '')}>
          <div className="portfolio-single-images">
            <div id={'hero-carousel-'+client.name} className='carousel slide' data-ride='carousel'>
              <div className='carousel-inner'>
                {client.links.map((image, i) => 
                <div className={'carousel-item' + (i == 0 ? ' active' : '')}>
                  <img className="lazyload" data-src={image.image} alt='First slide' />
                </div>)}
              </div>
              <a className='carousel-control-prev' href={'#hero-carousel-'+client.name} role='button' data-slide='prev'>
                <span className='carousel-control-prev-icon' aria-hidden='true'></span>
                <span className='sr-only'>Previous</span>
              </a>
              <a className='carousel-control-next' href={'#hero-carousel-'+client.name} role='button' data-slide='next'>
                <span className='carousel-control-next-icon' aria-hidden='true'></span>
                <span className='sr-only'>Next</span>
              </a>
            </div>
          </div>
          <div className="portfolio-single-details">
            <h2 className="title">Detalhes - {client.name}</h2>
            <p><strong>Ano:</strong> {client.year}</p>
            <p><strong>Modelo:</strong> {client.model}</p>
            <p><strong>Serviço:</strong> <br/>{client.jobs}</p>
          </div>
          <button className="close-button" onClick={this.hideClient}><FaClose /></button>
        </div>
      </div>
    );
  }
}


class Clients extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      clientsArray: [],
      showingClient: false
    }
  }

  componentDidMount() {
    return fetch('/api/v1/clients/')
      .then((response) => response.json())
      .then((responseJson) => {
        //console.log(responseJson)
        this.setState({
          clientsArray: responseJson
        })
      })
      .catch((e) => {
        //console.log(e)
      });
  }


  render() {

    var self = this
    const printClients = this.state.clientsArray.map((client, i) => {
      return <Client key={client.name} client={client}/>
    });

    return (
      <div className="clients-component" id="portfolio">
        <h2 className="title section-title">Portfólio</h2>
        <div className="title section-subtitle">
          Veja alguns dos nossos trabalhos. Clique num trabalho para mais detalhes
        </div>
        {/* <OwlCarousel className="owl-theme" margin={10} dots={true} lazyLoad={true} responsiveClass={true} autoplay={true}
          responsive={{
            300: {items: 1},
            500: {items: 3},
            1000: {items: 5}
          }}> */}
          <div className={'clients'}>
            { printClients }
          </div>
        {/* </OwlCarousel> */}
      </div>
    );
  }
}

Clients.displayName = 'Clients';

// Uncomment properties you need
// Clients.propTypes = {};
// Clients.defaultProps = {};

export default Clients;



// WEBPACK FOOTER //
// ./src/components/Portfolio.js